
/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import {periodService} from "../views/Simulations/services";

const state = {
  periods: []
};
const getters = {
  getPeriods: (state) => state.periods,
};
const actions = {
  getPeriodsAction({ commit }) {
    periodService.fetchPeriods().then(
      (result) => {
        commit("setPeriods", result);
      }, (error) => {console.log(error);}
    );
  }
};
const mutations = {
  setPeriods(state, val) {
    state.periods = val;
  }
};

export const period = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
